import moment from 'moment';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showReportIncidentPopup } from '~/actions';

export const useReportIncidentItem = (job) => {
  const dispatch = useDispatch();

  // Checks if an incident has already been reported for the job
  const isReported = !!job?.incident;

  // Calculate minutes elapsed since shift start (positive = shift has started)
  const minutesSinceShiftStart = moment().diff(moment(job?.shift?.start), 'minutes');

  // Determines if the shift has started
  const isShiftNotStartedYet = minutesSinceShiftStart < 0;

  // Determines if the job can be reported (30+ minutes since shift start)
  const canReport = minutesSinceShiftStart >= 30;

  // shift already started but less than 30 minutes
  const isShiftStartedLessThan30Minutes =
    minutesSinceShiftStart >= 0 && minutesSinceShiftStart < 30;

  const onReportIncidentClick = useCallback(() => {
    dispatch(
      showReportIncidentPopup({
        job,
        professionalName: job?.professional?.full_name,
        canReport,
      }),
    );
  }, [canReport, dispatch, job]);

  return {
    isReported,
    canReport,
    onReportIncidentClick,
    isShiftStartedLessThan30Minutes,
    isShiftNotStartedYet,
  };
};
